import { render, staticRenderFns } from "./AdminRouterOutlet.vue?vue&type=template&id=7d531568"
import script from "./AdminRouterOutlet.vue?vue&type=script&lang=js"
export * from "./AdminRouterOutlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports